// 트랙 R4b-v2 — KPI 분야 코드 → 아이콘 + 색 단일 진실 소스 utility.
//
// Dashboard.jsx 의 KPI_ICON_MAP / KPI_COLOR_MAP 인라인 정의를 흡수.
// KpiIndicatorCard 본체에서도 동일 utility 를 사용하여 분야 아이콘/색 표시.
import { FaChartLine, FaCogs, FaTruck, FaBug } from 'react-icons/fa';

export const KPI_ICON_MAP = {
  P: FaChartLine, // 생산성 Productivity
  C: FaCogs,      // 원가 Cost
  D: FaTruck,     // 납기 Delivery
  Q: FaBug,       // 품질 Quality
};

export const KPI_COLOR_MAP = {
  P: '#8884d8',
  C: '#ffc658',
  D: '#82ca9d',
  Q: '#ff4d4f',
};

const FALLBACK_ICON = FaChartLine;
const FALLBACK_COLOR = '#aaa';

export const getKpiFieldIcon = (fieldCd) => KPI_ICON_MAP[fieldCd] || FALLBACK_ICON;
export const getKpiFieldColor = (fieldCd) => KPI_COLOR_MAP[fieldCd] || FALLBACK_COLOR;
export const getKpiFieldDisplay = (fieldCd) => ({
  Icon: getKpiFieldIcon(fieldCd),
  color: getKpiFieldColor(fieldCd),
});
